<template>
  <div class="user_bind">
    <div class="title">
      <span>账号绑定</span>
    </div>
    <div class="line"></div>
    <div class="bind_item" v-for="(item,index) in bindList" :key="index">
      <div class="logo">
        <img :src="item.logo" alt />
      </div>
      <div class="test">
        <span>{{item.test}}</span>
      </div>
      <div class="state">
        <span>{{item.state==0?'未绑定':`已绑定：${userName}`}}</span>
      </div>
      <div class="btn">
        <span class="com_link" @click="bindUser(item.state)">{{item.state==0?'点击绑定':'解除绑定'}}</span>
      </div>
    </div>
    <el-dialog title="绑定微信账号" :visible.sync="elVisible" :close-on-press-escape="false" :close-on-click-modal="false" width="438px" @close="closeVisible">
      <div ref="qrcode" class="qrcode" id="qrcode"></div>
    </el-dialog>
  </div>
</template>

<script>
import QRCode from "qrcodejs2";
export default {
  metaInfo: { title: "账号绑定 - 个人中心" },
  name: "userBind",
  props: {
    GetWechatQrCode: {
      type: Function,
      default: () => {},
    },
    GetUserByPlat: {
      type: Function,
      default: () => {},
    },
    UnBindWechat: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      bindList: [
        {
          type: 1,
          logo: require("@/assets/img/we_logo.png"),
          test: "绑定微信账号",
          state: 0,
        },
      ],
      elVisible: false,
      ajaxInterval: null,
      userName: undefined,
    };
  },
  mounted() {
    // 先获取一次绑定状态用来展示
    this.getUserInfo("get");
  },
  beforeDestroy() {
    //清除轮询
    clearInterval(this.ajaxInterval);
    this.ajaxInterval = null;
  },
  methods: {
    bindUser(state) {
      if (state == 1) {
        this.$confirm("您确定要解除绑定微信账号？", "您确定要解除绑定？", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            this.unBind();
          })
          .catch(() => {});
      } else {
        // 每次点击绑定清空上次的轮询
        clearInterval(this.ajaxInterval);
        this.ajaxInterval = null;
        this.elVisible = true;
        this.GetWechatQrCode().then((res) => {
          // console.log("获取微信绑定信息二维码", res);
          // 生成二维码
          this.createQR(res.data[0].qrCode);
          // ajax轮询获取绑定状态
          this.ajaxInterval = setInterval(() => {
            this.getUserInfo("ajax");
          }, 3000);
        });
      }
    },
    createQR(code) {
      let qrcode = new QRCode("qrcode", {
        width: 300,
        height: 300, // 高度
        text: code, // 二维码内容
        render: "canvas", // 设置渲染方式（有两种方式 table和canvas，默认是canvas）
        colorDark: "#000000",
        colorLight: "#ffffff",
        correctLevel: QRCode.CorrectLevel.H,
      });
      // 不展示title
      this.$refs.qrcode.title = "";
    },
    closeVisible() {
      // 清空二维码
      this.$refs.qrcode.innerHTML = "";
    },
    getUserInfo(type) {
      this.GetUserByPlat().then((res) => {
        // console.log("是否绑定微信", res.data[0]);
        this.bindList[0].state = res.data[0].userInfo.isBindWeChatId;
        this.userName = res.data[0].userInfo.weChatNickName;
        if (type == "ajax") {
          if (res.data[0].userInfo.isBindWeChatId == 1) {
            clearInterval(this.ajaxInterval);
            this.ajaxInterval = null;
            this.elVisible = false;
            this.$alert("您已成功绑定微信账号！", "绑定成功", {
              confirmButtonText: "确定",
              type: "success",
              showClose: false,
            });
          }
        }
      });
    },
    unBind() {
      this.UnBindWechat().then((res) => {
        // console.log("解绑微信", res);
        this.bindList[0].state = 0;
        this.$alert("您已成功解绑微信账号", "解绑成功", {
          confirmButtonText: "确定",
          type: "success",
          showClose: false,
        });
      });
    },
  },
};
</script>

<style lang="less" scoped>
.user_bind {
  .title {
    height: 40px;
    line-height: 40px;
    padding: 0px 31px;
    background: rgba(244, 244, 244, 1);
  }
  .line {
    margin-top: 20px;
    height: 1px;
    background-color: #f4f4f4;
  }
  .bind_item {
    height: 100px;
    box-sizing: border-box;
    padding-left: 20px;
    padding-right: 15px;
    border-bottom: 1px dashed #bfbfbf;
    display: flex;
    align-items: center;
    font-weight: 400;
    font-size: 12px;
    .logo {
      width: 31px;
      height: 30px;
      background: #f4f4f4;
      border-radius: 5px;
    }
    .test {
      padding-left: 15px;
      font-size: 14px;
      color: #1a1a1a;
    }
    .state {
      padding-left: 30px;
      color: @themeColor;
      width: 266px;
      box-sizing: border-box;
    }
    .btn {
      color: #006cc8;
      width: calc(100% - 396px);
      text-align: right;
    }
  }
  .qrcode {
    width: 300px;
    height: 300px;
    margin: 0 auto;
  }
}
</style>